<template>
    <div class="py-1 px-1 flex-grow-1 d-flex flex-column" v-loading="isLoading">
        <div class="flex-grow-1  d-flex flex-column">
            <div class="d-flex align-items-center">
                <div class="flex-fill">
                    <div class="text-muted">Available Voucher/ Coupon</div>
                </div>
                <div>
                    <el-button size="small" icon="el-icon-refresh" circle @click="refresh()"></el-button>
                </div>
            </div>
            <VuePerfectScrollbar class="mt-1 flex-fill" style="height: 100px;">
                <div>
                    <div>
                        <div class="coupon-voucher-container">
                            <CouponVoucherItem v-for="item in availableCouponVoucher" :key="item.id" :item="item" 
                                :buttonTrigger="getNow"/>
                        </div>
                    </div>
                </div>
            </VuePerfectScrollbar>
        </div>
        <div style="height: 50px;">

        </div>
        <div style="background-color: #f5f5f5; border-radius: 8px;" class="py-3 px-3 flex-grow-1  d-flex flex-column">
            <div class="d-flex align-items-center">
                <div class="flex-fill">
                    <div class="text-muted">My Voucher/ Coupon</div>
                </div>
                <div>
                    <el-button size="small" icon="el-icon-refresh" circle @click="refresh()"></el-button>
                </div>
            </div>
            <VuePerfectScrollbar class="mt-1 flex-fill" style="height: 100px;">
                <div>
                    <div>
                        <div class="coupon-voucher-container">
                            <CouponVoucherItem v-for="item in myCouponVoucher" :key="item.uuidv7" :item="item"
                                :isMyList="true" :buttonTrigger="useNow"/>
                        </div>
                    </div>
                </div>
            </VuePerfectScrollbar>
        </div>

        <el-dialog :title="null" :show-close="false" class="action-for-coupon-voucher-dialog"
            :destroy-on-close="true"
            :visible.sync="dialogVisible" width="100%" style="">
            <div slot="title" class="text-right">
                 <el-button size="mini" type="danger" icon="ri-close-line" circle @click="dialogVisible = false"></el-button>
            </div>
            <div v-if="currentComponent != null"> 
                <component :is="currentComponent" :currentItem="currentItem"
                    @onRequestReloadList="refresh()"/>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import promotionApi from '@/api/promotionApi';
import { EXECUTE_RESULT } from "@/constant/baseConstant";
import CouponVoucherItem from "./CouponVoucherItem.vue";

const componentMap = {
    'ShowcaseContribution': () => import('@/views/Promotion/CouponPopup/ShowcaseContributionPopup.vue'),
    'ShowcaseYourAnimation': () => import('@/views/Promotion/CouponPopup/ShowcaseYourAnimationPopup.vue'),
    'SocialAmbassador': () => import('@/views/Promotion/CouponPopup/SocialAmbassadorPopup.vue'),
    'SurveyReward': () => import('@/views/Promotion/CouponPopup/SurveyRewardPopup.vue'),
    'RedeemVoucher': () => import('@/views/Promotion/CouponPopup/RedeemVoucherPopup.vue'),
}

export default {
    components: {
        CouponVoucherItem
    },
    data() {
        return {
            isLoading: false,
            availableCouponVoucher: [],
            myCouponVoucher: [],
            dialogVisible: false,
            currentItem: null,
            currentComponent: null,
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        async getAvailableCouponVoucher() {
            const res = await promotionApi.getAvailableCouponVoucher();
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.availableCouponVoucher = data.data;
                }
            }
        },
        async getMyCouponVoucher() {
            const res = await promotionApi.getMyCouponVoucher();
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.myCouponVoucher = data.data;
                }
            }
        },
        async refresh() {
            this.isLoading = true;
            this.getAvailableCouponVoucher();
            this.getMyCouponVoucher();
            this.isLoading = false;
        },
        getNow(item) {
            this.currentItem = item;
            switch (item.code)
            {
                case "SURVEY_REWARD":
                    this.currentComponent = componentMap['SurveyReward'] || null;
                    break;
                case "SHOWCASE_CONTRIBUTION":
                    this.currentComponent = componentMap['ShowcaseContribution'] || null;
                    break;
                case "SOCIAL_AMBASSADOR":
                    this.currentComponent = componentMap['SocialAmbassador'] || null;
                    break;
                case "SHOWCASE_YOUR_ANIMATION":
                    this.currentComponent = componentMap['ShowcaseYourAnimation'] || null;
                    break;
                case "VOUCHER_BONUS":
                    this.currentComponent = componentMap['RedeemVoucher'] || null;
                    break;
            }
            this.dialogVisible = true;
        },
        async useNow(item) {
            this.isLoading = true;
            await this.getMyCouponVoucher();
            const finalItem = this.myCouponVoucher.find(x => x.issueId === item.issueId);
            if(finalItem != null)
            {
                if (finalItem.isExpired)
                {
                    this.$alert('This voucher has expired.', 'Oh! Something went wrong.');
                    this.isLoading = false;
                    return;
                }

                if (finalItem.isUsed)
                {
                    this.$alert('This voucher has already been used', 'Oh! Something went wrong.');
                    this.isLoading = false;
                    return;
                }
                this.$router.push('/payment-management?issueId=' + item.issueId);
            }
            else{
                this.$alert('Voucher not found', 'Oh! Something went wrong.');
                this.isLoading = false;
                return;
            }
            this.isLoading = false;
        }
    }
}
</script>